import { FC, useState } from 'react';
import {
  Course,
  useListCoursesQuery,
} from '../../services/generated/studentPortalApi';
import {
  Button,
  Card,
  AutoCompleteInput,
  Radio,
  useMediaQuery,
  AutoCompleteItem,
} from '@versita/frontend/campus-ui-web';
import { map, pipe, prop, propEq, range, sortBy } from 'ramda';
import { useNavigate } from 'react-router-dom';
import { useHandleQueryError } from '@versita/frontend/api-utils';

export const useListCoursesQueryArgs = {};

/**
Page for selecting a course (programme) to view the timetable for
*/
export const CourseSelect: FC = () => {
  const navigate = useNavigate();
  const { data } = useHandleQueryError(
    useListCoursesQuery(useListCoursesQueryArgs),
  );
  const isDesktop = useMediaQuery('(min-width: 768px)');
  const [selectedItemId, setSelectedItem] = useState<string | null>(null);
  const [selectedYear, setSelectedYear] = useState<string | null>(null);
  const clearSelectedYear = () => setSelectedYear(null);
  const selectedItem = data?.find(propEq(selectedItemId || '', 'id'));
  const numYears = selectedItem?.numYears || 3;

  const goToCourse = () => {
    if (selectedItem && selectedYear) {
      navigate(`/course/${selectedItemId}/${selectedYear}`);
    }
  };
  return (
    <div>
      <Card
        $fullWidth={true}
        style={{ maxWidth: '64rem' }}
        onClick={(e) => e.stopPropagation()}
      >
        <form>
          <AutoCompleteInput
            label="Course Name"
            description="Search for a course name (or code if you know it)"
            id="course-name-search"
            items={mapCourseList(data || [])}
            onSelectItem={pipe(prop('id'), setSelectedItem, clearSelectedYear)}
          />
          <Radio
            legend="Course Year"
            name="course-year"
            disabled={!selectedItemId}
            value={selectedYear}
            inputProps={{
              onChange: (e) => {
                setSelectedYear(e.currentTarget.value);
              },
            }}
            items={range(1, numYears + 1).map((year) => ({
              id: `year-${year}`,
              label:
                isDesktop && numYears < 7
                  ? (
                      {
                        1: 'First Year',
                        2: 'Second Year',
                        3: 'Third Year',
                        4: 'Fourth Year',
                        5: 'Fifth Year',
                        6: 'Sixth Year',
                      } as Record<number, string>
                    )[year]
                  : String(year),
              value: String(year),
            }))}
          />
          <Button
            type="button"
            disabled={!selectedYear}
            onClick={goToCourse}
            $fullWidth={true}
            data-testid="view-timetable-button"
          >
            View Timetable
          </Button>
        </form>
      </Card>
    </div>
  );
};

const mapCourseList = pipe(
  sortBy(prop('name')),
  map<Course, AutoCompleteItem>(({ id, name }) => ({
    id,
    label: name,
    secondaryLabel: id.replace(/\./g, '/'),
  })),
);

export default CourseSelect;
